import {FlowController} from "./FlowController";
import {collapseIframe} from "../../widget/misc/WidgetUtils";
import {Messages} from "../../Messages";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";

export class CloseController extends FlowController {
    onClick() {
        collapseIframe();
    }

    getActionButtonDefaultLabel() {
        return Messages.close;
    }
}

export class LinkController extends FlowController {
    getActionButtonDefaultLabel() {
        return "";
    }
}

export class RefreshController extends FlowController {
    onClick(event) {
        iFrameConnection.sendToSDK(IFrameMessages.REEVALUATE_PANEL_OPTIONS);
    }
}
